var $ = require('jquery');
var _ = require('underscore');
var obfuscate = require('../../src/lib/obfuscate.js');
var Storage = require('./storage.js');

/**
 * Track video viewing time.
 *
 * Usage:
 *   var videoTracker = new VideoTracker;
 *   videoTracker.setup(player);
 *   videoTracker.start();
 *   videoTracker.stop();
 *
 */
module.exports = function () {

    // Player instance
    var player;

    // Logged time in seconds
    var logged = 0;

    // The id of the interval
    var intervalId;

    // Storage
    var storage = new Storage();

    // Is communication with the remote server in progess?
    var sending = false;

    /**
     * Setup.
     *
     * @param {Object} instance
     */
    this.setup = function (instance) {
        player = instance;
    };

    /**
     * Track viewing time of a video.
     */
    this.start = function() {
        intervalId = player.setInterval(function() {
            /**
             * Check readyState (3 = HAVE_FUTURE_DATA) to confirm enough data is available
             * to advance the current playback position.
             */
            if (player.readyState() > 3) {
                logged++;

                throttledStore();
                throttledSend();
            }
        }, 1000);
    };

    /**
     * Stop tracking viewing time of a video.
     */
    this.stop = function() {
        player.clearInterval(intervalId);

        /**
         * When the playback stops it's a good signal to send the logged time to the server.
         */
        this.send();
    };

    /**
     * Get current viewing time from storage. Attempt to clarify the obfuscated time from
     * storage, if that fails, return 0.
     *
     * @return {Number}
     */
    var getCurrentTime = function() {
        var playerId = player.id();
        var time = storage.get(playerId);

        if (!time) {
            return 0;
        }

        try {
            time = parseInt(time.clarify());
        } catch (e) {
            time = 0;
            setCurrentTime(time);
        }

        return time;
    };

    /**
     * Set current viewing time in storage.
     *
     * @param {Number} time
     */
    var setCurrentTime = function(time) {
        var playerId = player.id();

        storage.set(playerId, obfuscate(time));
    };

    /**
     * Store viewing time of the video.
     */
    this.store = function() {
        setCurrentTime(getCurrentTime() + logged);

        logged = 0;
    };

    /**
     * Send viewing time of the video.
     */
    this.send = function() {
        var loggedTime;
        var playerId = player.id();
        var fileId = playerId.split('-').pop();

        loggedTime = getCurrentTime() + logged;

        /**
         * Skip it if logged time is less than 3s or communication with the remote server
         * is already in progress.
         */
        if (loggedTime < 3 || sending) {
            return;
        }

        sending = true;

        $.ajax({
            url: '/video-log/'+fileId+'/log',
            method: 'PUT',
            dataType: 'json',
            data: {
                watched: loggedTime
            }
        }).done(function(data) {
            setCurrentTime(0);
            logged = 0;
        }).always(function() {
            sending = false;
        });
    };

    /**
     * Debounced store method.
     */
    var throttledStore = _.throttle(this.store, 5000, { leading: true });

    /**
     * Debounced send method.
     */
    var throttledSend = _.throttle(this.send, 30000, { leading: true });
}
